
import Header from '../src/components/Header'
import Footer from '../src/components/Footer'
import AOS from 'aos'
import 'aos/src/sass/aos.scss';
export default {
  components: {
    Header,
    Footer
  },
  created () {
    AOS.init({ once: true, offset: 0, startEvent: 'load' })
  },
}
